import Footer from "../components/Footer";
import { GameWrapper } from "../styles/game";
import {useSelector} from "react-redux";
import { ChangeEvent, useState, useEffect } from "react";
import detectEthereumProvider from "@metamask/detect-provider";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnect from "@walletconnect/client";

const { ethereum } = window;

const ticketContract = "0x9c9F19434D2f0154b3dc04913c9e02A0dD969E52";
const ticketABI = [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"string","name":"_baseTokenURI","type":"string"},{"internalType":"uint256","name":"_maxSupply","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"previousAdminRole","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"newAdminRole","type":"bytes32"}],"name":"RoleAdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleGranted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleRevoked","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"DEFAULT_ADMIN_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"_wallets","type":"address[]"}],"name":"addToWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"}],"name":"burnBach","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"burnedUsers","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"currentSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_specialUser","type":"address"},{"internalType":"uint256","name":"_specialUserAllocation","type":"uint256"}],"name":"defineSpecialUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"}],"name":"getRoleAdmin","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getRoleMember","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"}],"name":"getRoleMemberCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"_wallets","type":"address[]"}],"name":"removeFromWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"renounceRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"revokeRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"safeMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_baseTokenURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"specialUser","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"specialUserAllocation","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}];

const Game = () => {
  const {publicKey, walletType} = useSelector(state => state.wallet);
  const [isLogin, setIsLogin] = useState(false);
  const [isLock, setIsLock] = useState(false);
  const [isBurned, setIsBurned] = useState(false);
  const [isStaked, setIsStaked] = useState(false);
  const [gameCodeVal, setGameCodeVal] = useState("not_valid");
  const [userWallet, setUserWallet] = useState("");
  const [walletPubKeyState, setWaletPubKeyState] = useState("not_valid");
  const [userNfts, setUserNfts] = useState([]);
  const [userBetaTickets, setUserBetaTickets] = useState([]);

  useEffect(() => {
    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gamecode = urlParams.get('code');
    setGameCodeVal(gamecode);
  }, []);


  const mintNFT = async () => {
    if(walletType=="metamask" || walletType=="") { 

      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(ticketABI,ticketContract);
      await abiInterface.methods.safeMint().send({from: ethereum.selectedAddress});
      alert("Minting is done!");

    } else if(walletType=="walletconnect"){
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
      await provider.enable();
      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();
      const abiInterface = new web3Instance.eth.Contract(ticketABI,ticketContract);
      await abiInterface.methods.safeMint().send({from: accounts[0]}); 
    }
  }

  const loginWallet = async () => {

    if(walletPubKeyState !== "not_valid") {
      var data = JSON.stringify({
        "code":gameCodeVal,
        "walletAddress":walletPubKeyState,
        "nftId":userNfts,
        "burnedTickets":null,
        "loginType":"OpenBeta"});
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let arrresp = JSON.parse(this.responseText);
          if(arrresp.status==true) {
            document.getElementById("cuzdan_alani").innerText ="Successful! You can go back to the game.";
            document.getElementById("cuzdan_alani").style.color ="green";
          } else {
            document.getElementById("cuzdan_alani").innerText ="Failed!";
            document.getElementById("cuzdan_alani").style.color ="red";
          }

        }
      });
      xhr.open("POST", "https://betaapi.heroeschained.com/session/login");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);
    } else {
      alert("Please login with your wallet!");
    }

  }

  const verifyWallet = async () => {
    setIsLogin(true);

    if(walletType=="metamask" || walletType=="") { 
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      document.getElementById("walletpubkeyid").innerText = ethereum.selectedAddress;
      setWaletPubKeyState(ethereum.selectedAddress);

      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(ticketABI,ticketContract);
      // let userTickets = await abiInterface.methods.balanceOf(ethereum.selectedAddress).call({from: ethereum.selectedAddress});
      // setUserBetaTickets(userTickets);
      
      var data = JSON.stringify({"walletAddress":ethereum.selectedAddress});
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          let defaultNfts = respreal.data;
          setUserNfts(defaultNfts);
        }
      });
      xhr.open("POST", "https://betaapi.heroeschained.com/api/check/nft");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);

      var data2 = JSON.stringify({"walletAddress":ethereum.selectedAddress});
      var xhr2 = new XMLHttpRequest();
      xhr2.withCredentials = false;
      xhr2.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          setIsLock(respreal.status);

        }
      });
      xhr2.open("POST", "https://betaapi.heroeschained.com/session/check/whitelist");
      xhr2.setRequestHeader("Content-Type", "application/json");
      xhr2.send(data2);

      var data3 = JSON.stringify({"walletAddress":ethereum.selectedAddress});
      var xhr3 = new XMLHttpRequest();
      xhr3.withCredentials = false;
      xhr3.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          setIsStaked(respreal.status);

        }
      });
      xhr3.open("POST", "https://betaapi.heroeschained.com/api/check/stake");
      xhr3.setRequestHeader("Content-Type", "application/json");
      xhr3.send(data3);



    } else if (walletType=="walletconnect") { 
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
  
      await provider.enable();
      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();

      const abiInterface = new web3Instance.eth.Contract(ticketABI,ticketContract);
      // let userTickets = await abiInterface.methods.balanceOf(ethereum.selectedAddress).call({from: accounts[0]});
      // setUserBetaTickets(userTickets);

      document.getElementById("walletpubkeyid").innerText = accounts[0];
      setWaletPubKeyState(accounts[0]);

      var data = JSON.stringify({"walletAddress":accounts[0]});
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          let defaultNfts = respreal.data;
          setUserNfts(defaultNfts);
        }
      });
      xhr.open("POST", "https://betaapi.heroeschained.com/api/check/nft");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);

      var data2 = JSON.stringify({"walletAddress":accounts[0]});
      var xhr2 = new XMLHttpRequest();
      xhr2.withCredentials = false;
      xhr2.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          setIsLock(respreal.status);

        }
      });
      xhr2.open("POST", "https://betaapi.heroeschained.com/session/check/whitelist");
      xhr2.setRequestHeader("Content-Type", "application/json");
      xhr2.send(data2);

      var data3 = JSON.stringify({"walletAddress":accounts[0]});
      var xhr3 = new XMLHttpRequest();
      xhr3.withCredentials = false;
      xhr3.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
          let respreal = JSON.parse(this.responseText);
          setIsStaked(respreal.status);

        }
      });
      xhr3.open("POST", "https://betaapi.heroeschained.com/api/check/stake");
      xhr3.setRequestHeader("Content-Type", "application/json");
      xhr3.send(data3);

    }
  }
  return (
    <GameWrapper>
      <div style={{ backgroundColor: '#1b2026', color: 'white', textAlign: 'center' }}>
        <h1>Heroes Chained Beta Game</h1>
        <br/>
        <br/>
    {(gameCodeVal=='not_valid' || gameCodeVal==null) ?  
    <div class="flex-col space-y-2 justify-center items-center"> 
  
    <div id="beforewallet">    
     <p style={{cursor:'pointer'}}>
     <span className="spanbutton" onClick={() => mintNFT()} style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px', textAlign:'center', cursor:'pointer'}}>Mint Ticket NFT</span>
      </p>
     </div>
   </div> :
     <div class="flex-col space-y-2 justify-center items-center">

     {!isLogin && <span className="spanbutton" onClick={() => verifyWallet()} style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px', textAlign:'center', cursor:'pointer'}}>Verify My Wallet</span>} 
   
     {isLogin && <div id="beforewallet">
     <p id="cuzdan_alani" class="text-lg text-gray-600 my-2"><b>Wallet Public Key: </b><span id="walletpubkeyid"></span></p>
      <p class="text-lg text-gray-600 my-2"><b>Game Code: </b><span id="gamecodeid">{gameCodeVal}</span></p>
      <p>
      <span className="spanbutton" onClick={() => loginWallet()} style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px', textAlign:'center', cursor:'pointer'}}>Login With My Wallet</span>
       </p>
      </div> }
      <br/>
      <br/>
      
      
    </div>
  }
      </div>
      <Footer />
    </GameWrapper>
  )
}

export default Game;